import React, { FC, useState } from 'react';
import { ColorDLS } from '../../styling/color';
import { LinearProgress, MuiPickersUtilsProvider, Typography } from '@dls/react-core';
import { SubmitHandler } from 'react-hook-form';
import { RoutePaths } from '../../routes/main-routes';
import DateFnsUtils from '@date-io/date-fns';
import { PageWrapper, StyledContainer } from '../../components/styled/styles';
import { BackNavigationHeader } from '../../components/styled/back-navigation-header';
import { StudyForm, StudyFormFields } from '../../components/studies/study-form';
import { useNavigate } from 'react-router-dom';
import { createStudy } from '../../api/studykit';
import { startOfDay, endOfDay } from 'date-fns';

export const CreateStudy: FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit: SubmitHandler<StudyFormFields> = async (data, event) => {
    const startDate = startOfDay(new Date(data.start)).toISOString();
    const endDate = endOfDay(new Date(data.end)).toISOString();
    data = {
      ...data,
      start: startDate,
      end: endDate,
    };
    setIsSubmitting(true);
    await createStudy(data)
      .then(() => {
        navigate(`/${RoutePaths.Studies}`);
      })
      .catch((e: Error) => {
        console.error(e);
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <PageWrapper>
      {isSubmitting && <LinearProgress variant={'indeterminate'} />}
      <BackNavigationHeader navigateTo={`/${RoutePaths.Studies}`} title={`Add Study`} />
      <StyledContainer>
        {isSubmitting && <LinearProgress variant={'indeterminate'} />}
        <Typography variant="h2" style={{ color: ColorDLS.Blue45 }}>
          Study details
        </Typography>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <StudyForm
            onSubmit={onSubmit}
            onCancel={() => navigate(`/${RoutePaths.Studies}`)}
            submitButtonText="Create"
          />
        </MuiPickersUtilsProvider>
      </StyledContainer>
    </PageWrapper>
  );
};
